module.exports = __webpack_public_path__ + "static/media/fakes012000.7fa05220.png";